var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhy5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.557,
    height: 39.508,
    viewBox: "0 0 35.557 39.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-disaster-recovery-plan-3683431",
    transform: "translate(-140 -17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M173.582,19.475h-1.975a1.981,1.981,0,0,0-1.975-1.975H141.975A1.981,1.981,0,0,0,140,19.475v34.9a2.631,2.631,0,0,0,2.634,2.634h27a1.981,1.981,0,0,0,1.975-1.975h1.975a1.981,1.981,0,0,0,1.975-1.975V21.451A1.981,1.981,0,0,0,173.582,19.475Zm-32.265,0a.66.66,0,0,1,.658-.658h27.656a.66.66,0,0,1,.658.658V51.082a.66.66,0,0,1-.658.658h-27a2.654,2.654,0,0,0-1.317.354Zm28.314,36.216h-27a1.317,1.317,0,0,1,0-2.634h27a2.016,2.016,0,0,0,.658-.115v2.091a.66.66,0,0,1-.658.658Zm4.609-2.634a.66.66,0,0,1-.658.658h-1.975V51.74h1.317V50.424h-1.317V47.79h1.317V46.473h-1.317V43.839h1.317V42.522h-1.317V39.888h1.317V38.571h-1.317V35.937h1.317V34.62h-1.317V31.986h1.317V30.669h-1.317V28.036h1.317V26.719h-1.317V24.085h1.317V22.768h-1.317V20.792h1.975a.66.66,0,0,1,.658.658Z",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M204.352,102.455a11.852,11.852,0,1,0-4.881-22.66l.543,1.2a10.542,10.542,0,1,1-3.317,2.362l.42,2.107,1.292-.255-.782-3.918-4.576.765.214,1.3,1.975-.329a11.846,11.846,0,0,0,9.112,19.424Z",
    transform: "translate(-48.549 -56.641)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M250.926,148.75v2.634h-5.268v7.9H245V160.6h15.8v-1.317h-.658V148.75Zm7.9,1.317v9.219h-6.585v-9.219ZM246.975,152.7h3.951v6.585h-3.951Z",
    transform: "translate(-97.098 -121.373)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M393.75,183.75h1.317v1.317H393.75Z",
    transform: "translate(-234.654 -153.739)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M393.75,218.75h1.317v1.317H393.75Z",
    transform: "translate(-234.654 -186.105)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M393.75,253.75h1.317v1.317H393.75Z",
    transform: "translate(-234.654 -218.471)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M288.75,218.75h1.317v1.317H288.75Z",
    transform: "translate(-137.556 -186.105)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M288.75,253.75h1.317v1.317H288.75Z",
    transform: "translate(-137.556 -218.471)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M358.75,183.75h1.317v1.317H358.75Z",
    transform: "translate(-202.288 -153.739)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M358.75,218.75h1.317v1.317H358.75Z",
    transform: "translate(-202.288 -186.105)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M358.75,253.75h1.317v1.317H358.75Z",
    transform: "translate(-202.288 -218.471)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M253.75,420h14.486v1.317H253.75Z",
    transform: "translate(-105.19 -372.21)",
    fill: "#3d73ec"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy5);
export default __webpack_public_path__ + "static/media/why5.8216d60d31db6f2c5ade34fa9196d211.svg";
export { ForwardRef as ReactComponent };